import { Box, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import cuid from 'cuid';
import PropTypes from 'prop-types';
import React from 'react';
import { SingleLinePreview, StyledArticlePreviewContainer, StyledButtonBase } from './NewsArticles.styled';

const ArticlePreview = ({ displayStartDate, handleOpen, newsType, title, previewSingleLine }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <StyledArticlePreviewContainer display={isSmall ? 'block' : 'flex'} mb={isSmall ? 2 : 'inherit'} key={cuid()}>
      {displayStartDate && (
        <Box mr={2}>
          <Typography>{displayStartDate}</Typography>
        </Box>
      )}
      <StyledButtonBase onClick={handleOpen} title={title}>
        <Typography color={newsType === 'yellow-news' ? 'initial' : 'secondary'} align={isSmall ? 'left' : 'inherit'}>
          {previewSingleLine ? <SingleLinePreview>{title}</SingleLinePreview> : <Box>{title}</Box>}
        </Typography>
      </StyledButtonBase>
    </StyledArticlePreviewContainer>
  );
};

ArticlePreview.propTypes = {
  displayStartDate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  handleOpen: PropTypes.func,
  title: PropTypes.string,
  newsType: PropTypes.oneOf(['inside-news', 'yellow-news', null]),
  previewSingleLine: PropTypes.bool,
};

export default ArticlePreview;
